import { deleteCoreAiAgentSlice } from './delete';
import { getCoreAiAgentSlice } from './get';

export const { requestGetCoreAiAgent, resetGetCoreAiAgent } =
	getCoreAiAgentSlice.asyncActionCreators;

export const { requestDeleteCoreAiAgent, resetDeleteCoreAiAgent } =
	deleteCoreAiAgentSlice.asyncActionCreators;

export * from './tools/actions';
